import React from 'react'
import PropTypes from 'prop-types';
import axios from "axios";
import * as Icon from 'react-feather';
import { Link } from "react-router-dom";
import BookEmployerBiodataShared from '../employers/BookEmployerBiodataShared';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const SuperBiodataCard = ({  activeTab,item}) => {

  const { user } = useAuth();




  return (
    <div className="bg-white p-3 rounded-bottom mb-5 w-100 ">
      <div className="d-flex justify-content-end mb-2 py-2 rounded">
      
       

        {/* Center - profile */}
        <div className="flex-grow-1 text-center">
          <Link
            to={{
              pathname: !user ? `/biodata-employer/${item.id}` : `/biodata/${item.id}`,
              state: { profile: item },
            }}
            className="avatar avatar-md mb-2"
            style={{ width: 100, height: 100 }}
          >
            {item.imgprofile ? (
              <img
                className="avatar-img rounded-circle"
                src={item.imgprofile}
                width="200"
                alt="User"
              />
            ) : (
              <i className="fas fa-user text-muted position-absolute top-50 start-50 translate-middle" style={{ fontSize: "27px" }}></i>
            )}
          </Link>
        </div>

        {/* Right - badge */}
        <div>
          {item.status === "Published" ? (
            <span className="badge bg-success-light">
              <Icon.CheckCircle size={17} /> { item.status}
           
            </span>
          ) : item.status === "Draft" ? (
            <span className="badge bg-info">
              <Icon.AlertCircle size={17} /> {item.status}
            </span>
          ) : item.status === "On-Hold" ? (
            <span className="badge bg-light border text-dark">
              <Icon.PauseCircle size={17} /> {item.status}
            </span>
          ) : item.status === "Booked" ? (
            <span className="badge bg-primary-light border text-dark">
              <Icon.BookOpen size={17} /> {item.status}
            </span>
          ) : (
            <span className="badge bg-dark border text-light">
              <Icon.MinusCircle size={17} /> {item.status}
            </span>
          )}
          
        </div>
      </div>



      {/* Header Section */}
      <div className='d-flex justify-content-between align-items-start mb-4'>
        <div className='flex-grow-1'>
          <h5 className="fw-bold text-dark mb-1 lh-base">{item.name}</h5>
        </div>
        <div className='ms-3'>
          <span className='badge bg-light text-muted px-3 py-2 rounded-pill fw-medium' style={{fontSize: '0.875rem'}}>{item.code}</span>
        </div>
      </div>

      {/* Profile Information Section */}
      <div className='mb-4'>
        <h6 className='fw-bold text-dark mb-3 text-uppercase' style={{letterSpacing: '0.5px', fontSize: '0.875rem'}}>
          Profile Information
        </h6>
        <div className='profile-details'>
          <div className='d-flex align-items-start py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}} 
               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
            <div style={{minWidth: '160px', flexShrink: 0}}>
              <span className='text-muted fw-medium'>Created By</span>
            </div>
            <div style={{flex: 1, marginLeft: '20px'}}>
              <CreatedBy activeTab={activeTab} user={user} record={item}/>
            </div>
          </div>
          
          <div className='d-flex align-items-start py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}}
               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
            <div style={{minWidth: '160px', flexShrink: 0}}>
              <span className='text-muted fw-medium'>Shared With Employers</span>
            </div>
            <div style={{flex: 1, marginLeft: '20px'}}>
              <div className='d-flex flex-wrap gap-1'>
                {item.shared_with_employer.map((employer, index) => (
                  <span key={index} className="badge bg-primary bg-opacity-10 text-primary px-2 py-1 rounded-pill fw-medium border border-primary border-opacity-25" style={{fontSize: '0.75rem'}}>
                    {employer}
                  </span>
                ))}
              </div>
            </div>
          </div>
          
          <div className='d-flex align-items-center py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}}
               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
            <div style={{minWidth: '160px', flexShrink: 0}}>
              <span className='text-muted fw-medium'>Created At</span>
            </div>
            <div style={{flex: 1, marginLeft: '20px'}}>
              <span className='text-dark fw-medium'>{item.created_at}</span>
            </div>
          </div>
          
          <div className='d-flex align-items-center py-2 px-2' style={{transition: 'all 0.2s ease'}}
               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
            <div style={{minWidth: '160px', flexShrink: 0}}>
              <span className='text-muted fw-medium'>Last Modified</span>
            </div>
            <div style={{flex: 1, marginLeft: '20px'}}>
              <span className='text-dark fw-medium'>{item.updated_at}</span>
            </div>
          </div>
        </div>
      </div>
     
     
      
    </div>
  )
}
function capitalizeFirstChar(str) {
  if (!str) return ''; // handle empty string
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const CreatedBy = ({activeTab,user,record})=>{

   const companyType = activeTab === "agency" ? "agency" : "supplier";
    const userData = record[companyType];
    
    const companyInfo = userData?.[companyType] || {};

    

    const isAdmin = userData?.is_admin ? "Admin" : "Staff";

    const companyName = typeof companyInfo.name === "string" 
      ? companyInfo.name 
      : JSON.stringify(companyInfo.name ?? "N/A");

    const adminEmail = typeof companyInfo.admin_email === "string"
      ? companyInfo.admin_email
      : JSON.stringify(companyInfo.admin_email ?? "N/A");

    return (
      <div className='text-dark'>
        <div className='mb-2'>
          <span className='fw-medium'>{capitalizeFirstChar(record[companyType].name)}</span>
          <span className='ms-2 badge bg-secondary bg-opacity-25 text-secondary px-2 py-1 rounded-pill' style={{fontSize: '0.7rem'}}>{isAdmin}</span>
        </div>
        <div className='small text-muted mb-1'>
          <strong>Company:</strong> {companyName}
        </div>
        <div className='small text-muted'>
          <strong>Email:</strong> {adminEmail}
        </div>
      </div>
    );
}
CreatedBy.propTypes = {

  record: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  activeTab: PropTypes.string.isRequired


};
SuperBiodataCard.propTypes = {

  item: PropTypes.object.isRequired,
   activeTab: PropTypes.string.isRequired

};

export default SuperBiodataCard